import type { Camper, SearchProductsItem } from '@yescapa-dev/ysc-api-js'

export const getCamperDisplayTravelersCount = (camper: Pick<SearchProductsItem | Camper, 'vehicle_beds' | 'vehicle_seatbelts'>) => {
  return Math.min(...[camper.vehicle_beds, camper.vehicle_seatbelts])
}
